import { useReducer, useCallback } from 'react';
import useSafeDispatch from './safe-dispatch';

function asyncReducer(state, action) {
  switch (action.type) {
    case 'pending': {
      return { status: 'pending', data: null, error: null };
    }
    case 'resolved': {
      return { status: 'resolved', data: action.data, error: null };
    }
    case 'rejected': {
      return { status: 'rejected', data: null, error: action.error };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

export default function useAsync() {
  const [state, unsafeDispatch] = useReducer(asyncReducer, {
    status: 'idle',
    data: null,
    error: null,
  });

  const dispatch = useSafeDispatch(unsafeDispatch);

  const { status, data, error } = state;

  const run = useCallback(
    (promise) => {
      if (!promise) {
        return;
      }
      dispatch({ type: 'pending' });
      return promise
        .then((data) => {
          dispatch({ type: 'resolved', data });
          return data;
        })
        .catch((error) => {
          dispatch({ type: 'rejected', error });
          return error;
        });
    },
    [dispatch]
  );

  return {
    data,
    error,
    status,
    run,
    isIdle: status === 'idle',
    isPending: status === 'pending',
    isResolved: status === 'resolved',
    isRejected: status === 'rejected',
  };
}
